import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { useOrganization } from "@domain/organization/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap } from "@ui/styles/utils";
import { OrganizationEditor } from "./organizationEditor";

interface OrganizationEditionModalProps extends React.HTMLAttributes<HTMLDivElement> {
	organizationId: string;
	close: () => void;
}

export const OrganizationEditionModal: React.FC<OrganizationEditionModalProps> = ({
	organizationId,
	close,
	...htmlProps
}) => {
	const { loading, result: organization } = useOrganization(organizationId);

	return (
		<Container {...htmlProps} close={close} title={I18n.t("organization.edit.title")} keyboardEventDisabled>
			{organization ? (
				<OrganizationEditor initialOrganization={organization} organizationId={organizationId} onSave={close} />
			) : loading ? (
				<ClipLoader />
			) : null}
		</Container>
	);
};

const Container = styled(ClosableModal)`
	align-items: stretch;
	${gap(35)}
`;
